import React from 'react';
import { PlayCircle } from 'lucide-react';
import './VideoTestimonials.css';

const VideoTestimonials = () => {
  const videos = [
    {
      name: 'Aarav Sharma',
      title: 'AIR 12 - UPSC 2024',
      videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4',
      thumbnail: 'https://i.ibb.co/ZVh01dm/student1.jpg'
    },
    {
      name: 'Ishita Verma',
      title: 'AIR 5 - NEET 2024',
      videoUrl: 'https://www.w3schools.com/html/movie.mp4',
      thumbnail: 'https://i.ibb.co/0s3pdnc/student2.jpg'
    }
  ];

  return (
    <section className="video-testimonial-section">
      <div className="video-testimonial-container">
        <h2 className="video-testimonial-title">What Our Toppers Say</h2>
        <div className="video-testimonial-grid">
          {videos.map((vid, idx) => (
            <div className="video-testimonial-card" key={idx}>
              <div className="video-testimonial-thumbnail" style={{ backgroundImage: `url(${vid.thumbnail})` }}>
                <a href={vid.videoUrl} target="_blank" rel="noopener noreferrer" className="video-testimonial-play">
                  <PlayCircle className="video-testimonial-icon" size={40} />
                </a>
              </div>
              <div className="video-testimonial-details">
                <h4 className="video-testimonial-name">{vid.name}</h4>
                <p className="video-testimonial-rank">{vid.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoTestimonials;
